import "./Skills.module.css";
import Header from "@/reusable_sections/Header";
import ArchitetturaContrattuale from "./sections/ArchitetturaContrattuale";
import AssistanceTypes from "./sections/AssistanceTypes";
import ExtraordinaryOperations from "./sections/ExtraordinaryOperations";
import Footer from "@/reusable_sections/Footer";
export default function SkillsPage() {
  return <div>
      <Header />
      <ArchitetturaContrattuale />
      <AssistanceTypes />
      <ExtraordinaryOperations />
      <Footer />
    </div>;
}